import React, { FunctionComponent } from 'react'
import { View } from 'react-native'

import { tID } from '../../utils/utils'
import { BaseButton, BaseButtonProps, ButtonType } from '../baseButton/BaseButton'

export type CarouselButtonProps = Omit<BaseButtonProps, 'rightIcon' | 'buttonType' | 'text'>

export const CarouselButton: FunctionComponent<CarouselButtonProps> = (props) => {
  return (
    <View>
      <BaseButton testID={tID('CarouselButton')} buttonType={ButtonType.CAROUSEL} {...props} />
    </View>
  )
}
